<template>
  <div class="overflow: auto">
    <div class="top" style="font-size:18px">
      可提现金额（元）：
      <div style="font-size:50px">{{userData.surplusAmt/100}}</div>总金额（元）：
      <div style="font-size:50px">{{userData.rewardAmt/100}}</div>
      <Button
        type="primary"
        @click="modal1 = true"
        style="position: absolute;top: 149px;left: 244px; background: #2d8cf0;color: #FFF;font-size: 20px;padding: 0px 27px;"
      >提现</Button>
      <Modal v-model="modal1" title="提现" @on-ok="acquire">
        提现金额 ：
        <Input v-model="amount" placeholder="请输入提现金额" style="width: auto;margin-right:15px" />
        {{this.thisBankCard.bankName}}:
        {{this.thisBankCard.cardNo}}
        <br />
        <br />
        <Button
          type="primary"
          @click="bankCard = true;getBankCard()"
          style=" background: #2d8cf0;color: #FFF;font-size: 20px;padding: 0px 27px;"
        >选择银行卡</Button>
      </Modal>
      <Modal v-model="DeleteCard" title="解绑储蓄卡" @on-ok="DeleteBankCard()">是否解绑储蓄卡？</Modal>
      <Modal v-model="bankCard" title="选择银行卡">
        <div v-for="(data,index) in bankcardData" :key="index" style="position: relative;">
          <div
            @click="SelectBankCard(data)"
            style="border-bottom: 1px solid #ccc;height: 40px;line-height: 40px;overflow: hidden;cursor:pointer"
          >
            <img
              :src="data.logo"
              style="width: 20px;height: 20px;top: 9px;left: 10px;position: absolute;"
            />
            <div style="padding-left: 40px;">{{data.bankName}}{{data.cardNo}}</div>
          </div>
          <Button
            type="primary"
            @click="DeleteCard=true;DeleteCardId=data.id"
            style=" background: #2d8cf0;color: #FFF; font-size: 16px;padding: 0px 27px;float:right;top: 7px;right: 10px;position: absolute;"
          >解绑储蓄卡</Button>
        </div>
        <div style="height: 30px;width: 100%;">
          <Button
            type="primary"
            @click="binding=true;"
            style=" background: #2d8cf0;color: #FFF; font-size: 16px;padding: 0px 27px;float:right;margin-right: 10px;margin-top: 7px;"
          >绑定银行卡</Button>
        </div>
      </Modal>
      <Modal v-model="audit" title="实名认证" @on-ok="authentication">
        姓名 ：
        <Input v-model="auditUsername" placeholder="请输入姓名" style="width: auto;margin-right:15px" />
        <br />
        <br />身份证号：
        <Input v-model="auditIdNo" placeholder="请输入身份证号" style="width: auto" />
        <br />
        <br />银行卡号：
        <Input v-model="auditCardNo" placeholder="请输入银行卡号" style="width: auto" />
        <br />
        <br />手机号：
        <Input v-model="auditMobileNo" placeholder="请输入手机号" style="width: auto" />
      </Modal>
      <Modal v-model="binding" title="绑定银行卡" @on-ok="bindingBankCard">
        姓名 ：{{userData.username}}
        <br />
        <br />
        身份证号 ：{{userData.idNo}}
        <br />
        <br />银行卡号：
        <Input v-model="bindingData.cardNo" placeholder="请输入银行卡号" style="width: auto" />
        <br />
        <br />手机号：
        <Input v-model="bindingData.mobileNo" placeholder="请输入手机号" style="width: auto" />
      </Modal>
    </div>
    <Tabs type="card" @on-click="TabPane">
      <TabPane label="我的结算明细"></TabPane>
      <TabPane label="团队结算明细"></TabPane>
      <TabPane label="提现记录"></TabPane>
    </Tabs>
    <div class="query-c">
      查询：
      <Select
        v-if="condition=='Record'"
        v-model="state"
        style="width:200px;margin-left: 20px;"
        placeholder="请选择状态"
        @on-change="changeInput"
      >
        <Option
          v-for="(item, index)  in stateData"
          :value="item.value"
          :key="index"
        >{{ item.label }}</Option>
      </Select>
      <Select
        v-if="condition!='Record'"
        v-model="productId"
        style="width:200px;margin-left: 20px;"
        placeholder="请选择产品"
        @on-change="changeInput"
      >
        <Option
          v-for="(item, index)  in ProductData"
          :value="item.value"
          :key="index+'e'"
        >{{ item.label }}</Option>
      </Select>
      <Input
        v-model="userNname"
        v-if="condition!='MyDetail'&&condition!='Record'"
        @input="changeInput()"
        search
        placeholder="输入成员姓名"
        style="width: auto;margin-left: 20px;"
      />
      <Input
        v-model="name"
        v-if="condition!='MyDetail'&&condition!='Record'"
        @input="changeInput()"
        search
        placeholder="输入办卡人姓名"
        style="width: auto;margin-left: 20px;"
      />
      <Input
        v-model="phone"
        v-if="condition!='MyDetail'&&condition!='Record'"
        @input="changeInput()"
        search
        placeholder="输入办卡人手机号"
        style="width: auto;margin-left: 20px;"
      />
      <Input
        v-model="pincodes"
        v-if="condition!='MyDetail'&&condition!='Record'"
        @input="changeInput()"
        search
        placeholder="输入办卡人身份证"
        style="width: auto;margin-left: 20px;"
      />
      <DatePicker
        type="daterange"
        split-panels
        placeholder="按时间查询"
        style="width: 200px;margin-left:20px"
        @on-change="queryTime"
      ></DatePicker>
    </div>
    <br />
    <Table :content="self" border stripe :columns="columns1" :data="TableData"></Table>
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "SettleAccounts",

  data() {
    return {
      name: "",
      modal1: false,
      binding: false,
      DeleteCard: false,
      DeleteCardId: "",
      total: 0,
      condition: "MyDetail",
      productId: "",
      time: [],
      userNname: "",
      phone: "",
      self: this,
      bankCard: false,
      keyword: "",
      pageNow: 1,
      amount: "",
      state: "",
      pincodes: "",
      audit: false,
      auditUsername: "",
      ProductData: [],
      stateData: [
        {
          value: 0,
          label: "待处理"
        },
        {
          value: 1,
          label: "处理中"
        },
        {
          value: 2,
          label: "已驳回"
        },
        {
          value: 3,
          label: "已完成"
        },
        {
          value: 4,
          label: "失败"
        }
      ],
      userData: {},
      columns1: [],
      thisBankCard: {},
      TableData: [],
      auditIdNo: "",
      auditUsername: "",
      auditCardNo: "",
      auditMobileNo: "",
      bankcardData: [],
      bindingData: { cardNo: "", mobileNo: "" }
    };
  },
  mounted: function() {
    this.getData("");
    this.getProduct();
    this.GetDetail();
  },
  activated: function() {
    this.getData("");
    this.getProduct();
    this.GetDetail();
  },
  methods: {
    bindingBankCard() {
      api.SettleAdd(this.bindingData).then(res => {
        this.getBankCard();
      });
    },
    GetDetail() {
      api.GetDetail().then(res => {
        this.userData = res.body.data;
        if (res.body.data.idNo) {
          this.audit = false;
        } else {
          this.audit = true;
        }
      });
    },
    SelectBankCard(data) {
      this.thisBankCard = data;
      this.bankCard = false;
    },
    getBankCard() {
      api.settleList().then(res => {
        this.bankcardData = res.body.data;
        if (this.bankcardData.length == 0) {
          this.audit = true;
          this.bankCard = false;
        }
      });
    },
    DeleteBankCard() {
      api.SettleDel(this.DeleteCardId).then(res => {
        this.getBankCard();
      });
    },
    TabPane(type) {
      if (type == 0) {
        this.condition = "MyDetail";
      }
      if (type == 1) {
        this.condition = "AllDetail";
      }
      if (type == 2) {
        this.condition = "Record";
      }
      this.getData();
    },
    authentication() {
      api
        .UserRealm({
          idNo: this.auditIdNo,
          username: this.auditUsername,
          cardNo: this.auditCardNo,
          mobileNo: this.auditMobileNo
        })
        .then(res => {
          this.GetDetail();
        });
    },
    getData() {
      if (this.condition == "MyDetail") {
        this.columns1 = [
          {
            title: "结算时间",
            align: "center",
            key: "rewardTime"
          },
          {
            title: "结算类型",
            align: "center",
            key: "rewardType"
          },
          {
            title: "金额（元）",
            align: "center",
            key: "money"
          },
          {
            title: "结算来源",
            align: "center",
            key: "content"
          }
        ];
        api
          .GetUserProductRewardType({
            pageNow: this.pageNow,
            pageSize: "10",
            start: this.time[0],
            end: this.time[1],
            productId: this.productId
          })
          .then(res => {
            if (res.body.status == 310) {
              this.TableData = [];
              this.total = 0;
            } else {
              this.total = res.body.data.pageResult.total;
              this.TableData = res.body.data.pageResult.list;
              this.TableData.forEach(element => {
                element.money = element.money / 100;
                if (element.rewardType == 1) {
                  element.rewardType = "信用卡 ";
                }
                if (element.rewardType == 2) {
                  element.rewardType = "贷款 ";
                }
                if (element.rewardType == 3) {
                  element.rewardType = "优质客户进件奖励";
                }
                // if (element.userId == localStorage.getItem("userId")) {
                //   element.informationProductName = "团队差价";
                // } else {
                //   element.informationProductName =
                //     element.informationProductName;
                // }
              });
            }
          });
      }
      if (this.condition == "AllDetail") {
        this.columns1 = [
          {
            title: "团队成员",
            align: "center",
            key: "userParentName"
          },
          {
            title: "结算日期",
            align: "center",
            key: "rewardTime"
          },
          {
            title: "产品",
            align: "center",
            key: "informationProductName"
          },
          {
            title: "结算金额",
            align: "center",
            key: "money"
          },
          {
            title: "客户姓名",
            align: "center",
            key: "name"
          },
          {
            title: "客户手机号",
            align: "center",
            key: "phone"
          }
        ];

        api
          .getUserAllProductRewardType({
            pageNow: this.pageNow,
            pageSize: "10",
            start: this.time[0],
            end: this.time[1],
            productId: this.productId,
            userNname: this.userNname,
            name: this.name,
            phone: this.phone,
            pincodes: this.pincodes
          })
          .then(res => {
            if (res.body.status == 310) {
              this.TableData = [];
              this.total = 0;
            } else {
              this.total = res.body.data.pageResult.total;
              this.TableData = res.body.data.pageResult.list;
              this.TableData.forEach(element => {
                element.money = element.money / 100;
              });
            }
          });
      }
      if (this.condition == "Record") {
        this.columns1 = [
          {
            title: "提现账户",
            align: "center",
            key: "bankNo"
          },
          {
            title: "提现金额（元）",
            align: "center",
            key: "amount"
          },
          {
            title: "提现状态",
            align: "center",
            key: "state"
          },
          {
            title: "提现时间",
            align: "center",
            key: "createTime"
          },
          {
            title: "到账时间",
            align: "center",
            key: "settleTime"
          }
        ];

        api
          .DrawHistory({
            pageNow: this.pageNow,
            pageSize: "10",
            state: this.state,
            start: this.time[0],
            end: this.time[1]
          })
          .then(res => {
            if (res.body.status == 310) {
              this.TableData = [];
              this.total = 0;
            } else {
              this.total = res.body.data.total;
              this.TableData = res.body.data.list;
              this.TableData.forEach(element => {
                element.amount = element.amount / 100;
                if (element.state == 0) {
                  element.state = "待处理 ";
                }
                if (element.state == 1) {
                  element.state = "处理中 ";
                }
                if (element.state == 2) {
                  element.state = "已驳回 ";
                }
                if (element.state == 3) {
                  element.state = "已完成 ";
                }
                if (element.state == 4) {
                  element.state = "失败 ";
                }
              });
            }
          });
      }
    },
    getProduct() {
      api
        .ProductSelectAll({
          pageNow: 1,
          pageSize: "1000"
        })
        .then(res => {
          res.body.data.list.forEach(element => {
            this.ProductData.push({
              value: element.id,
              label: element.productName
            });
          });
        });
    },

    changeInput() {
      this.getData();
    },
    queryTime(time) {
      this.time[0] = new Date(time[0]).valueOf();
      this.time[1] = new Date(time[1]).valueOf();
      this.getData(this.keyword);
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData(this.keyword);
    },
    acquire() {
      if (this.thisBankCard.id) {
        api
          .DrawApply({
            amount: this.amount * 100,
            settleCardId: this.thisBankCard.id
          })
          .then(res => {
            this.$layer.alert(res.body.message);
            this.GetDetail();
          });
      } else {
        this.$layer.alert("请选择银行卡");
      }
    }
  }
};
</script>

<style scoped>
.top {
  height: 206px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>